export default __webpack_public_path__ + "static/media/bottom-part-pattern.0190a034.png";